/**
 * toc.js — sinh mục lục từ các thẻ h2 trong .entry-content và tô đậm mục đang đọc.
 *
 * Lấy heading trực tiếp từ nội dung nên trên WordPress không cần plugin hay
 * walker: chỉ cần giữ [data-toc] cho khung mục lục và [data-toc-source] cho
 * vùng the_content(). Không có h2 nào thì khối mục lục tự ẩn.
 */
(function () {
    'use strict';

    var container = document.querySelector('[data-toc]');
    var source = document.querySelector('[data-toc-source]');
    if (!container || !source) return;

    var headings = [].slice.call(source.querySelectorAll('h2'));
    if (headings.length < 2) {
        container.hidden = true;
        return;
    }
    container.hidden = false;

    var list = document.createElement('ul');
    list.className = 'toc__list';

    headings.forEach(function (heading, index) {
        if (!heading.id) {
            heading.id = 'section-' + (index + 1);
        }

        var item = document.createElement('li');
        var link = document.createElement('a');
        link.className = 'toc__link';
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
    });

    container.appendChild(list);

    var links = [].slice.call(list.querySelectorAll('.toc__link'));
    var ticking = false;

    function headerOffset() {
        var value = parseInt(
            getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
            10
        );
        return (isNaN(value) ? 190 : value) + 40;
    }

    function updateActive() {
        var offset = headerOffset();
        var current = headings[0];

        headings.forEach(function (heading) {
            if (heading.getBoundingClientRect().top <= offset) {
                current = heading;
            }
        });

        links.forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + current.id);
        });
    }

    window.addEventListener(
        'scroll',
        function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
                updateActive();
                ticking = false;
            });
        },
        { passive: true }
    );

    updateActive();
})();
